module.exports = __webpack_public_path__ + "img/img (2).cd2072f7.jpg";